export const environment = {
  // apiUrl: 'http://127.0.0.1:4159',
  apiUrl: 'https://c4653888cea6.datacompute.org',
  production: false,
};
